import { render, staticRenderFns } from "./DoctorForm.vue?vue&type=template&id=6de0cb6c&scoped=true"
import script from "./DoctorForm.vue?vue&type=script&lang=js"
export * from "./DoctorForm.vue?vue&type=script&lang=js"
import style0 from "./DoctorForm.vue?vue&type=style&index=0&id=6de0cb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de0cb6c",
  null
  
)

export default component.exports